import "core-js/modules/es.array-buffer.slice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/es.typed-array.uint8-array";
import "core-js/modules/es.typed-array.copy-within";
import "core-js/modules/es.typed-array.every";
import "core-js/modules/es.typed-array.fill";
import "core-js/modules/es.typed-array.filter";
import "core-js/modules/es.typed-array.find";
import "core-js/modules/es.typed-array.find-index";
import "core-js/modules/es.typed-array.for-each";
import "core-js/modules/es.typed-array.includes";
import "core-js/modules/es.typed-array.index-of";
import "core-js/modules/es.typed-array.iterator";
import "core-js/modules/es.typed-array.join";
import "core-js/modules/es.typed-array.last-index-of";
import "core-js/modules/es.typed-array.map";
import "core-js/modules/es.typed-array.reduce";
import "core-js/modules/es.typed-array.reduce-right";
import "core-js/modules/es.typed-array.reverse";
import "core-js/modules/es.typed-array.set";
import "core-js/modules/es.typed-array.slice";
import "core-js/modules/es.typed-array.some";
import "core-js/modules/es.typed-array.sort";
import "core-js/modules/es.typed-array.subarray";
import "core-js/modules/es.typed-array.to-locale-string";
import "core-js/modules/es.typed-array.to-string";
import _createForOfIteratorHelper from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/* globals window, document */

/**
 * @module adapter-ckfinder/utils
 */
var TOKEN_COOKIE_NAME = 'ckCsrfToken';
var TOKEN_LENGTH = 40;
var tokenCharset = 'abcdefghijklmnopqrstuvwxyz0123456789';
/**
 * Returns the CSRF token value. The value is a hash stored in `document.cookie`
 * under the `ckCsrfToken` key. The CSRF token can be used to secure the communication
 * between the web browser and the CKFinder server.
 *
 * @returns {String}
 */

export function getCsrfToken() {
  var token = getCookie(TOKEN_COOKIE_NAME);

  if (!token || token.length != TOKEN_LENGTH) {
    token = generateToken(TOKEN_LENGTH);
    setCookie(TOKEN_COOKIE_NAME, token);
  }

  return token;
}
/**
 * Returns the value of the cookie with a given name or `null` if the cookie is not found.
 *
 * @param {String} name
 * @returns {String|null}
 */

export function getCookie(name) {
  name = name.toLowerCase();
  var parts = document.cookie.split(';');

  var _iterator = _createForOfIteratorHelper(parts),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var part = _step.value;
      var pair = part.split('=');
      var key = decodeURIComponent(pair[0].trim().toLowerCase());

      if (key === name) {
        return decodeURIComponent(pair[1]);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
}
/**
 * Sets the value of the cookie with a given name.
 *
 * @param {String} name
 * @param {String} value
 */

export function setCookie(name, value) {
  document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + ';path=/';
} // Generates the CSRF token with the given length.
//
// @private
// @param {Number} length
// @returns {string}

function generateToken(length) {
  var result = '';
  var randValues = new Uint8Array(length);
  window.crypto.getRandomValues(randValues);

  for (var j = 0; j < randValues.length; j++) {
    var character = tokenCharset.charAt(randValues[j] % tokenCharset.length);
    result += Math.random() > 0.5 ? character.toUpperCase() : character;
  }

  return result;
}